/** Progress labels for DJ tools. Keys are internal; values are what a DJ may see. */
export const CHAT_TOOL_LABELS: Record<string, string> = {
  get_library_stats: 'Reading library stats',
  find_duplicate_tracks: 'Looking for duplicates',
  find_missing_tracks: 'Checking for missing files',
  search_tracks: 'Searching the library',
  list_tracks: 'Reading the library',
  summarize_tracks_by_key: 'Grouping library tracks by key',
  list_library_folders: 'Reading library folders',
  get_folder_tracks: 'Reading folder tracks',
  get_library_filter_facets: 'Reading library filters',
  list_recycle_bin: 'Reading the recycle bin',
  list_ignored_duplicate_groups: 'Reading ignored duplicates',
  ignore_duplicate_group: 'Ignoring a duplicate group',
  unignore_duplicate_group: 'Unignoring a duplicate group',
  get_last_health_report: 'Reading the last health report',
  get_serato_status: 'Checking Serato',
  list_serato_crates: 'Reading Serato crates',
  get_serato_crate_tracks: 'Reading Serato crate tracks',
  export_crate_to_serato: 'Writing a Serato crate',
  get_serato_library_root: 'Locating the Serato library',
  get_serato_play_counts: 'Reading Serato play counts',
  detect_import_sources: 'Detecting import sources',
  get_virtualdj_status: 'Checking VirtualDJ',
  list_virtualdj_playlists: 'Reading VirtualDJ playlists',
  get_virtualdj_play_counts: 'Reading VirtualDJ play counts',
  list_crowd_sessions: 'Reading crowd sessions',
  get_app_info: 'Reading app info',
  export_m3u: 'Writing an M3U playlist',
  get_streaming_connections: 'Checking streaming accounts',
  list_streaming_playlists: 'Reading streaming playlists',
  search_streaming_tracks: 'Searching streaming tracks',
  get_streaming_playlist_tracks: 'Reading streaming playlist tracks',
  export_crate_to_streaming: 'Building a streaming playlist',
  search_crate_hackers_crates: 'Searching Crate Hackers crates',
  get_track_recommendations: 'Finding compatible tracks',
  get_crate_hackers_crate: 'Reading a Crate Hackers crate',
  create_my_crate: 'Saving a My Crate',
  lookup_help: 'Checking how Crate Hackers works',
  list_automations: 'Reading saved automations',
  get_automation: 'Reading a saved automation',
  save_automation: 'Saving an automation',
  recycle_duplicate_files: 'Moving duplicates to the recycle bin',
  restore_recycled_tracks: 'Restoring recycled tracks',
  read_file: 'Reading files',
  read: 'Reading files',
  edit_file: 'Writing files',
  write: 'Writing files',
  run_terminal_cmd: 'Running command',
  shell: 'Running command',
  glob: 'Searching files',
  grep: 'Searching files',
  todo_write: 'Planning steps',
};
